import { render, staticRenderFns } from "./studentsList.vue?vue&type=template&id=18648f5d&scoped=true&"
import script from "./studentsList.vue?vue&type=script&lang=js&"
export * from "./studentsList.vue?vue&type=script&lang=js&"
import style0 from "./studentsList.vue?vue&type=style&index=0&id=18648f5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18648f5d",
  null
  
)

export default component.exports